export default {
    indexModule: { method: 'get', url: 'emcadmin/modules' },
    storeModule: { method: 'post', url: 'emcadmin/modules' },
    updateModule: { method: 'put', url: 'emcadmin/modules/{id}'},
    destroyModule: { method: 'delete', url: 'emcadmin/modules/{id}'},
}